import cls from 'classnames';
import React, { PureComponent } from 'react';
import { POLLS_QUESTION_TEXT_INPUT, POLLS_QUESTION_IMAGE } from '../../dataHooks.js';
import { withRCEHelpers, RCEHelpersPropTypes } from '../rce-helpers-context/index.js';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { PollContextPropTypes } from '../poll-context/types.js';
import { TextField } from '../text-field/TextField.js';
import { ImageUpload } from '../image-upload/ImageUpload.js';
import { withPoll } from '../poll-context/PollContext.js';
import 'prop-types';
import 'lodash';
import '../../assets/icons/LoaderIcon.js';
import 'react-measure';
import 'wix-rich-content-common/libs/imageUtils';
import '../../defaults-0542c304.js';
import '../image-upload/types.js';
import '../../assets/icons/ReplaceIcon.js';

var css_248z = "[dir] .vasV9{text-align:center}@supports not (contain:inline-size){@media only screen and (max-width:640px){.vasV9{font-weight:700}}}@container (width < 640px){.vasV9{font-weight:700}}.x5yr8{height:0}[dir] .x5yr8{margin-top:35px;padding-top:56.25%}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .x5yr8{margin-top:15px}}}@container (width < 640px){[dir] .x5yr8{margin-top:15px}}.jUHDN .x5yr8{height:150px}[dir] .jUHDN .x5yr8{border-radius:2px}";
var styles = {"title":"vasV9","image":"x5yr8","webview":"jUHDN"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class PollHeaderComponent extends PureComponent {
  render() {
    var _a, _b, _c;
    const { poll, changePollTitle, changePollImage, layout, t, rce } = this.props;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.header, {
          [styles.webview]: rce.isWebView
        })
      },
      /* @__PURE__ */ React.createElement(
        TextField,
        {
          autofocus: true,
          textAutoResize: true,
          maxLength: 160,
          className: styles.title,
          value: poll.title,
          onChange: changePollTitle,
          placeholder: t("Poll_Editor_Question_Placeholder"),
          dataHook: POLLS_QUESTION_TEXT_INPUT
        }
      ),
      ((_a = layout.poll) == null ? void 0 : _a.enableImage) && /* @__PURE__ */ React.createElement(
        ImageUpload,
        {
          dataHook: POLLS_QUESTION_IMAGE,
          disabled: rce.isPreview,
          className: styles.image,
          value: (_c = (_b = poll.image) == null ? void 0 : _b.src) == null ? void 0 : _c.url,
          onChange: changePollImage
        }
      )
    );
  }
}
const PollHeader = withRCEHelpers(withPoll(PollHeaderComponent));
PollHeaderComponent.propTypes = __spreadValues(__spreadValues({}, PollContextPropTypes), RCEHelpersPropTypes);

export { PollHeader };
//# sourceMappingURL=PollHeader.js.map
